import Hightlighter from 'react-highlight-words';
import ReactCountryFlag from 'react-country-flag';
import * as S from './ChooseCountries.styled';
import { ArrowDown, ArrowRightForSelectedGroup, CheckTree } from 'assets/icons';
import { Checkbox } from 'components';

const ChooseCountriesContent = ({
  search,
  countriesGroupsWithCountries,
  toggleOpenedGroup,
  isGroupOpened,
  isCountrySelected,
  toggleSelectedCountry,
  isGroupChecked,
  toggleCountriesGroup,
  isDirty$,
}) => {
  const countriesGroups = countriesGroupsWithCountries
    ? Object.keys(countriesGroupsWithCountries)
    : null;
  return (
    <>
      {countriesGroups?.map((country_name) => (
        <S.Group key={country_name}>
          <S.OpenGroupWrapper>
            <S.Row>
              <S.ArrowIconWrapper
                onClick={() => toggleOpenedGroup(country_name)}
                isOpen={isGroupOpened(country_name)}
              >
                {isGroupOpened(country_name) ? <ArrowDown /> : <ArrowRightForSelectedGroup />}
              </S.ArrowIconWrapper>
              <Checkbox
                id={country_name}
                isChecked={isGroupChecked(countriesGroupsWithCountries[country_name])}
                name={country_name}
                onChange={() => {
                  toggleCountriesGroup(countriesGroupsWithCountries[country_name]);
                  if (countriesGroupsWithCountries[country_name].length) {
                    isDirty$.value = false;
                  }
                }}
                isOpenGroup
              />
              <S.GroupName>
                <Hightlighter
                  textToHighlight={country_name}
                  searchWords={[search]}
                  highlightTag='strong'
                />
              </S.GroupName>
            </S.Row>
          </S.OpenGroupWrapper>
          <S.WrapForChooseRows>
            {isGroupOpened(country_name) &&
              countriesGroupsWithCountries[country_name]?.map(({ cca2, name, region }) => (
                <S.ChooseItemRow key={cca2}>
                  <S.Wrap>
                    <CheckTree />
                    <Checkbox
                      id={`checkbox-${cca2}`}
                      isChecked={isCountrySelected(cca2)}
                      name={cca2}
                      style={{ marginRight: '16px' }}
                      onChange={() => {
                        toggleSelectedCountry(cca2);
                        isDirty$.value = false;
                      }}
                    ></Checkbox>
                    <S.ItemName>
                      <ReactCountryFlag
                        countryCode={cca2}
                        svg
                        style={{
                          width: '20px',
                          height: '15px',
                          marginRight: '8px',
                        }}
                      />
                      <Hightlighter
                        textToHighlight={`${name} - ${cca2}`}
                        searchWords={[search]}
                        highlightTag='strong'
                      />
                    </S.ItemName>
                  </S.Wrap>
                  <S.ItemNameMarker>
                    <span>{region}</span>
                  </S.ItemNameMarker>
                </S.ChooseItemRow>
              ))}
          </S.WrapForChooseRows>
        </S.Group>
      ))}
    </>
  );
};

export default ChooseCountriesContent;
